import React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import AppBar from 'layouts/v2/AppBar';
import Banner from 'components/v2/Company/Banner';
import GladosNav from 'components/v2/AppLayoutLabs/GladosNav';
import SideNavigation from './SideNavigation';

import { BANNER_LINE_HEIGHT } from 'components/v2/Company/Banner';
import { FULL_LOGO_HEIGHT } from 'components/v2/PageElements/CompanyLogo';
import { getGladosNavUrl } from 'config';

import { withFeatureState } from './state';

const AppWrapper = styled(Box)(({ theme }) => ({
  minHeight: '100%',
  display: 'flex',
}));

const ContentWrapper = styled(Box)(({ paddingTop, theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingTop,
  width: '100%',
  position: 'relative',
}));

const GladosContentWrapper = styled(Box)({
  paddingTop: 90,
  width: '100%',
  minHeight: '100%',
});

const useUnifiedNav = !!getGladosNavUrl();

const DashboardLayout = ({ children, profile, preferences }) => {
  if (useUnifiedNav) {
    return (
      <>
        <GladosNav />
        <GladosContentWrapper>{children}</GladosContentWrapper>
      </>
    );
  }

  const bannerEnabled = profile?.company?.banner?.enabled;
  const paddingTop = `calc(${FULL_LOGO_HEIGHT - 15}px + ${bannerEnabled ? BANNER_LINE_HEIGHT : '0px'})`;

  return (
    <AppWrapper>
      <Banner />
      <AppBar />
      <SideNavigation />
      <ContentWrapper paddingTop={paddingTop}>{children}</ContentWrapper>
    </AppWrapper>
  );
};

export default withFeatureState(DashboardLayout);
